<template>
  <div class="message-card" @click="openModal">
    <div class="message-card__icon">
      <img v-if="item.icon" :src="item.icon" alt="icon" />
      <img v-else :src="getIconUrl(item.type)" alt="icon" />
    </div>
    <div class="message-card__content">
      <div class="message-card__title">{{ item.title }}</div>
      <div class="message-card__description" v-if="item.shortDescription">
        {{ item.shortDescription }}
      </div>
      <a v-if="computedLink" :href="computedLink.url" class="message-card__link" target="_blank" @click.stop>{{ truncLongString(computedLink.text, 33) }}
        →</a>
    </div>
  </div>
</template>

<script>
import { truncateString } from "@/utils";

export default {
  name: "MessageCard",
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    computedLink() {
      if (this.item.link) {
        return { url: this.item.link, text: this.item.titleLink };
      }
      if (this.item.type === "change_order_status") {
        return { url: "/history", text: "К заказам" };
      }
      if (this.item.type === "new_task") {
        return { url: "/history", text: "Подробнее" };
      }
      return null;
    },
  },
  methods: {
    truncLongString(str, lenght) {
      return truncateString(str, lenght);
    },
    openModal() {
      this.$emit("open", this.item);
    },
    getIconUrl(icon) {
      const icons = {
        new_task: require("../../assets/images/icons/warning-icon.svg"),
        important_news: require("../../assets/images/icons/warning-icon.svg"),
        change_order_status: require("../../assets/images/icons/delivery-icon.svg"),
      };
      return icons[icon];
    },
  },
};
</script>

<style lang="scss" scoped>
.message-card {
  display: flex;
  padding: 12px;
  gap: 12px;
  border-radius: 4px;
  background-color: $grey-bg;
  margin-bottom: 4px;
  width: 420px;
  height: auto;
  overflow-wrap: break-word;
  margin-bottom: 10px;

  &:hover {
    cursor: pointer;
    opacity: 0.9;
  }

  @include display-less(tablet) {
    width: 360px;
    height: 137px;
    margin-bottom: 5px;
  }
}

.message-card__icon {
  width: 101px;
  height: 101px;
  margin-right: 7px;
}

.message-card__icon img {
  width: 100px;
  height: 100px;
   border-radius: 4px;
}

.message-card__content {
  display: flex;
  flex-direction: column;
}

.message-card__title {
  font: 500 16px/26px $roboto;
  color: $white;
  margin-bottom: 8px;
  overflow-wrap: break-word;
  hyphens: auto;
  width: 268px;

   @include display-less(tablet) {
    width: 200px;
  }
}

.message-card__description {
  font: 500 14px/26px $roboto;
  color: $gray-card;
  margin: 5px 0;
  overflow-wrap: break-word;
  hyphens: auto;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  width: 268px;


   @include display-less(tablet) {
    font: 400 14px/23px $roboto;
    width: 180px;
    hyphens: none;
    display: -webkit-box;
    -webkit-line-clamp: 2;
  }
}

.message-card__link {
  font: 400 14px/17px $roboto;
  color: $blue-card;
  text-decoration: none;
  margin-top: auto;
  width: fit-content;
}
</style>
